'use client'

import { useState, useEffect } from 'react'

export interface Category {
  id: string
  name: string
  slug: string
  description: string | null
  imageUrl: string | null
  createdAt: Date
  updatedAt: Date
  order: number // 👈 NUEVO
}

export function useCategories() {
  const [categories, setCategories] = useState<Category[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch('/api/categories')
        if (!response.ok) {
          throw new Error('Error al cargar las categorías')
        }

        const data = await response.json()

        // 👇 ORDENAMOS ANTES DE GUARDAR
        const sorted = data.sort(
          (a: Category, b: Category) => (a.order ?? 0) - (b.order ?? 0)
        )

        setCategories(sorted)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error desconocido')
      } finally {
        setLoading(false)
      }
    }

    fetchCategories()
  }, [])

  return { categories, loading, error }
}
